import React from 'react';
import clsx from 'clsx';
import { Header, Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import SystemFlag from '../SystemFlag';

const TabHeader = ({
  className,
  headerId = 'click.to.edit',
  headerText,
  icon,
  isSystem,
  onClick,
  renderSystemFlag = () => <SystemFlag />,
}) => {
  const intl = useIntl();
  return (
    <Header
      as={onClick ? 'a' : 'h2'}
      size="medium"
      className={clsx('aridhia-tab-header aridhia-h2', className)}
      onClick={onClick}
    >
      {icon && (<Icon name={icon} className="primary" />)}
      <Header.Content content={headerText || intl.formatMessage({ id: headerId })} />
      {isSystem && renderSystemFlag()}
    </Header>
  );
};

export default TabHeader;
